import { Link } from "react-router-dom";
import CallToActionBackgroundImg from "../../assets/img_frame_427319473.webp"
import { Button, Text, Heading } from "../../components";
import React from "react";

export default function ConsultationCallToActionSection() {
  return (
    <>
      {/* consultation call to action section */}
      <div>
        <div className="flex h-[442px] flex-col items-center justify-center bg-cover bg-no-repeat py-[76px] md:h-auto md:py-[60px] sm:py-5"
          style={{ backgroundImage: `url(${CallToActionBackgroundImg})`}}>
          <div className="container-xs mt-[22px] flex flex-col items-center gap-[52px] px-14 md:px-5 sm:gap-[26px]">
            <div className="mr-2.5 flex w-full flex-col items-center gap-3.5 md:w-full">
              <Heading
                as="h3"
                size="heading10xl"
                className=" font-bold text-color_style-01_neutrals-grey50 md:text-[42px] sm:text-[24px] text-center"
              >
                Still thinking it over?
              </Heading>
              <Text
                size="text9xl"
                as="p"
                className="text-center text-[24px] font-normal leading-[37px] text-color_style-02_primary_blue-blue100 md:text-[22px] sm:text-[18px] sm:leading-6"
              >
                Talk to our experts to know what our digital twin <br />
                solution can do for your factory.
              </Text>
            </div>
            <Link to="/bookademo">
              <Button
                size="3xl"
                shape="round"
                className="min-w-[154px] rounded-[10px] px-6 font-bold tracking-[-0.60px] sm:px-5 sm:text-[14px]"
              >
                Get a Demo
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
